import React, { useState, useEffect } from 'react';
import { Plus, Download, ArrowUp, ArrowDown } from 'lucide-react';
import { toast } from 'sonner';

const GameDayOperations = () => {
  // State
  const [scheduleFilter, setScheduleFilter] = useState('all');
  const [selectedGame, setSelectedGame] = useState(null);
  const [games, setGames] = useState([]);

  // Sample games data
  const sampleGames = [
    {
      id: 1,
      opponent: 'Lakers',
      isHome: true,
      teamScore: 112,
      opponentScore: 108,
      date: 'Jan 25',
      type: 'Game',
      result: 'W',
      quarters: [
        { q: 1, home: 28, away: 25 },
        { q: 2, home: 30, away: 27 },
        { q: 3, home: 26, away: 28 },
        { q: 4, home: 28, away: 28 },
      ],
      stats: {
        home: { fg: '42/88', fgPct: '47.7%', twoPt: '31/62', twoPtPct: '50.0%', threePt: '11/26', threePtPct: '42.3%', ft: '17/20', ftPct: '85.0%', oreb: 8, dreb: 36, ast: 24 },
        away: { fg: '40/85', fgPct: '47.1%', twoPt: '30/60', twoPtPct: '50.0%', threePt: '10/25', threePtPct: '40.0%', ft: '18/22', ftPct: '81.8%', oreb: 10, dreb: 34, ast: 22 },
      }
    },
    {
      id: 2,
      opponent: 'Warriors',
      isHome: true,
      teamScore: 118,
      opponentScore: 115,
      date: 'Jan 22',
      type: 'Game',
      result: 'W',
      quarters: [
        { q: 1, home: 32, away: 28 },
        { q: 2, home: 28, away: 30 },
        { q: 3, home: 30, away: 29 },
        { q: 4, home: 28, away: 28 },
      ],
      stats: {
        home: { fg: '45/92', fgPct: '48.9%', twoPt: '32/60', twoPtPct: '53.3%', threePt: '13/32', threePtPct: '40.6%', ft: '15/18', ftPct: '83.3%', oreb: 10, dreb: 38, ast: 28 },
        away: { fg: '44/90', fgPct: '48.9%', twoPt: '30/58', twoPtPct: '51.7%', threePt: '14/32', threePtPct: '43.8%', ft: '13/17', ftPct: '76.5%', oreb: 9, dreb: 35, ast: 30 },
      }
    },
    {
      id: 3,
      opponent: 'Nuggets',
      isHome: false,
      teamScore: 120,
      opponentScore: 124,
      date: 'Jan 20',
      type: 'Game',
      result: 'L',
      quarters: [
        { q: 1, home: 28, away: 30 },
        { q: 2, home: 32, away: 33 },
        { q: 3, home: 30, away: 31 },
        { q: 4, home: 30, away: 30 },
      ],
      stats: {
        home: { fg: '46/95', fgPct: '48.4%', twoPt: '34/65', twoPtPct: '52.3%', threePt: '12/30', threePtPct: '40.0%', ft: '16/20', ftPct: '80.0%', oreb: 7, dreb: 32, ast: 25 },
        away: { fg: '48/92', fgPct: '52.2%', twoPt: '36/62', twoPtPct: '58.1%', threePt: '12/30', threePtPct: '40.0%', ft: '16/19', ftPct: '84.2%', oreb: 12, dreb: 40, ast: 28 },
      }
    },
    {
      id: 4,
      opponent: 'Suns',
      isHome: true,
      teamScore: 115,
      opponentScore: 110,
      date: 'Jan 18',
      type: 'Game',
      result: 'W',
      quarters: [
        { q: 1, home: 30, away: 28 },
        { q: 2, home: 28, away: 27 },
        { q: 3, home: 29, away: 28 },
        { q: 4, home: 28, away: 27 },
      ],
      stats: {
        home: { fg: '44/88', fgPct: '50.0%', twoPt: '32/58', twoPtPct: '55.2%', threePt: '12/30', threePtPct: '40.0%', ft: '15/18', ftPct: '83.3%', oreb: 9, dreb: 35, ast: 26 },
        away: { fg: '42/90', fgPct: '46.7%', twoPt: '30/60', twoPtPct: '50.0%', threePt: '12/30', threePtPct: '40.0%', ft: '14/18', ftPct: '77.8%', oreb: 8, dreb: 33, ast: 24 },
      }
    },
    {
      id: 5,
      opponent: '76ers',
      isHome: false,
      teamScore: 98,
      opponentScore: 104,
      date: 'Jan 15',
      type: 'Game',
      result: 'L',
      quarters: [
        { q: 1, home: 24, away: 26 },
        { q: 2, home: 25, away: 27 },
        { q: 3, home: 24, away: 26 },
        { q: 4, home: 25, away: 25 },
      ],
      stats: {
        home: { fg: '38/85', fgPct: '44.7%', twoPt: '28/58', twoPtPct: '48.3%', threePt: '10/27', threePtPct: '37.0%', ft: '12/16', ftPct: '75.0%', oreb: 6, dreb: 30, ast: 20 },
        away: { fg: '40/82', fgPct: '48.8%', twoPt: '30/55', twoPtPct: '54.5%', threePt: '10/27', threePtPct: '37.0%', ft: '14/18', ftPct: '77.8%', oreb: 10, dreb: 36, ast: 24 },
      }
    },
    {
      id: 6,
      opponent: 'Heat',
      isHome: true,
      teamScore: 108,
      opponentScore: 102,
      date: 'Jan 12',
      type: 'Game',
      result: 'W',
      quarters: [
        { q: 1, home: 27, away: 25 },
        { q: 2, home: 28, away: 26 },
        { q: 3, home: 26, away: 25 },
        { q: 4, home: 27, away: 26 },
      ],
      stats: {
        home: { fg: '42/86', fgPct: '48.8%', twoPt: '32/60', twoPtPct: '53.3%', threePt: '10/26', threePtPct: '38.5%', ft: '14/17', ftPct: '82.4%', oreb: 8, dreb: 34, ast: 24 },
        away: { fg: '40/88', fgPct: '45.5%', twoPt: '30/62', twoPtPct: '48.4%', threePt: '10/26', threePtPct: '38.5%', ft: '12/16', ftPct: '75.0%', oreb: 7, dreb: 32, ast: 22 },
      }
    },
  ];

  useEffect(() => {
    setGames(sampleGames);
    setSelectedGame(sampleGames[0]);
  }, []);

  // Filter games
  const filteredGames = games.filter(game => {
    if (scheduleFilter === 'all') return true;
    if (scheduleFilter === 'won') return game.result === 'W';
    if (scheduleFilter === 'lost') return game.result === 'L';
    return true;
  });

  // Compare stats and return indicator
  const compareStats = (homeVal, awayVal, higherIsBetter = true) => {
    const home = parseFloat(homeVal.toString().replace('%', '').replace('/', '.'));
    const away = parseFloat(awayVal.toString().replace('%', '').replace('/', '.'));
    
    if (higherIsBetter) {
      return home > away ? 'better' : home < away ? 'worse' : 'equal';
    }
    return home < away ? 'better' : home > away ? 'worse' : 'equal';
  };

  return (
    <div className="min-h-screen bg-black p-4 md:p-6">
      <div className="max-w-[1800px] mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-white">Game Day Operations</h1>
          <p className="text-gray-400 mt-1">Game Statistics & Analysis</p>
        </div>

        <div className="flex gap-6">
          {/* Left Sidebar - Schedule */}
          <div className="w-80 flex-shrink-0">
            <div className="bg-[#1a1a2e] border border-gray-800 rounded-xl p-4">
              {/* Header */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-white font-semibold text-lg">SCHEDULE</h2>
                <button 
                  onClick={() => toast.info('Add new game')}
                  className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white text-sm rounded-md transition-colors"
                >
                  New
                </button>
              </div>

              {/* Filter Tabs */}
              <div className="flex gap-2 mb-4">
                {['all', 'lost', 'won'].map(filter => (
                  <button
                    key={filter}
                    onClick={() => setScheduleFilter(filter)}
                    className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium capitalize transition-colors ${
                      scheduleFilter === filter 
                        ? 'bg-gray-700 text-white' 
                        : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
                    }`}
                  >
                    {filter}
                  </button>
                ))}
              </div>

              {/* Games List */}
              <div className="space-y-3 max-h-[600px] overflow-y-auto">
                {filteredGames.map(game => (
                  <div 
                    key={game.id}
                    onClick={() => setSelectedGame(game)}
                    className={`p-4 rounded-lg cursor-pointer transition-colors ${
                      selectedGame?.id === game.id 
                        ? 'bg-gray-700 border border-gray-600' 
                        : 'bg-gray-800/50 hover:bg-gray-800'
                    }`}
                  >
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-white font-medium">
                        {game.isHome ? 'vs' : '@'} {game.opponent}
                      </span>
                      <span className={`px-2 py-1 rounded text-xs font-bold ${
                        game.result === 'W' 
                          ? 'bg-green-500 text-white' 
                          : 'bg-orange-500 text-white'
                      }`}>
                        {game.result}
                      </span>
                    </div>
                    <p className="text-white font-bold text-lg">
                      {game.teamScore} - {game.opponentScore}
                    </p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-gray-500 text-sm">{game.date}</span>
                      <span className="text-gray-500 text-sm">{game.type}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Main Content */}
          {selectedGame && (
            <div className="flex-1 space-y-6">
              {/* Game Score Card */}
              <div className="bg-[#1a1a2e] border border-gray-800 rounded-xl p-6">
                <h3 className="text-center text-gray-400 text-lg mb-6">VS</h3>
                
                <div className="flex items-center justify-center gap-8">
                  {/* Home Team */}
                  <div className="flex items-center gap-4">
                    <span className="text-white text-xl font-medium">Celtics</span>
                    <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                      CE
                    </div>
                    <span className="text-white text-5xl font-bold">{selectedGame.teamScore}</span>
                  </div>

                  {/* Quarter Scores Table */}
                  <div className="border border-gray-700 rounded-lg overflow-hidden">
                    <table className="text-sm">
                      <thead>
                        <tr className="bg-gray-800">
                          <th className="px-3 py-2 text-gray-400 font-normal">Q</th>
                          <th className="px-3 py-2 text-gray-400 font-normal">Home</th>
                          <th className="px-3 py-2 text-gray-400 font-normal">Away</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedGame.quarters.map(q => (
                          <tr key={q.q} className="border-t border-gray-700">
                            <td className="px-3 py-2 text-gray-400 text-center">{q.q}</td>
                            <td className="px-3 py-2 text-white text-center">{q.home}</td>
                            <td className="px-3 py-2 text-white text-center">{q.away}</td>
                          </tr>
                        ))}
                        <tr className="border-t border-gray-700 bg-gray-800/50">
                          <td className="px-3 py-2 text-gray-400 text-center font-medium">T</td>
                          <td className="px-3 py-2 text-white text-center font-bold">{selectedGame.teamScore}</td>
                          <td className="px-3 py-2 text-white text-center font-bold">{selectedGame.opponentScore}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Away Team */}
                  <div className="flex items-center gap-4">
                    <span className="text-white text-5xl font-bold">{selectedGame.opponentScore}</span>
                    <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-orange-400 rounded-full flex items-center justify-center text-white font-bold text-xl">
                      LA
                    </div>
                    <span className="text-white text-xl font-medium">{selectedGame.opponent}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-4 mt-8">
                  <button className="flex-1 py-4 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors">
                    See Game Details
                  </button>
                  <button className="px-6 py-4 bg-gray-800 hover:bg-gray-700 text-white font-medium rounded-lg transition-colors flex items-center gap-2">
                    <Download size={18} />
                    Export Video/Data
                  </button>
                </div>
              </div>

              {/* Stats Comparison */}
              <div className="bg-[#1a1a2e] border border-gray-800 rounded-xl p-6">
                <div className="flex items-center justify-between mb-6">
                  {/* Home Team Badge */}
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    CE
                  </div>
                  
                  <div className="flex-1 px-8">
                    {/* Stats Rows */}
                    <div className="space-y-4">
                      {[
                        { label: 'FG', homeKey: 'fg', awayKey: 'fg' },
                        { label: 'FG%', homeKey: 'fgPct', awayKey: 'fgPct' },
                        { label: '2P', homeKey: 'twoPt', awayKey: 'twoPt' },
                        { label: '2P%', homeKey: 'twoPtPct', awayKey: 'twoPtPct' },
                        { label: '3P', homeKey: 'threePt', awayKey: 'threePt' },
                        { label: '3P%', homeKey: 'threePtPct', awayKey: 'threePtPct' },
                        { label: 'FT', homeKey: 'ft', awayKey: 'ft' },
                        { label: 'FT%', homeKey: 'ftPct', awayKey: 'ftPct' },
                        { label: 'OREB', homeKey: 'oreb', awayKey: 'oreb' },
                        { label: 'DREB', homeKey: 'dreb', awayKey: 'dreb' },
                        { label: 'AST', homeKey: 'ast', awayKey: 'ast' },
                      ].map(stat => {
                        const homeVal = selectedGame.stats.home[stat.homeKey];
                        const awayVal = selectedGame.stats.away[stat.awayKey];
                        const homeStatus = compareStats(homeVal, awayVal);
                        const awayStatus = homeStatus === 'better' ? 'worse' : homeStatus === 'worse' ? 'better' : 'equal';
                        
                        return (
                          <div key={stat.label} className="flex items-center">
                            {/* Home Value */}
                            <div className="flex-1 flex items-center justify-end gap-3">
                              <span className="text-white font-medium">{homeVal}</span>
                              {homeStatus === 'better' && <ArrowUp size={16} className="text-green-400" />}
                              {homeStatus === 'worse' && <ArrowDown size={16} className="text-orange-400" />}
                            </div>
                            
                            {/* Label */}
                            <div className="w-20 text-center">
                              <span className="text-gray-400 text-sm">{stat.label}</span>
                            </div>
                            
                            {/* Away Value */}
                            <div className="flex-1 flex items-center gap-3">
                              {awayStatus === 'better' && <ArrowUp size={16} className="text-green-400" />}
                              {awayStatus === 'worse' && <ArrowDown size={16} className="text-orange-400" />}
                              <span className="text-white font-medium">{awayVal}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Away Team Badge */}
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-orange-400 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    LA
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameDayOperations;
